// ChangePhenologicalPhaseDate.js

import { useState, useEffect, useRef  } from "react";
import { Box, Text, Button, Layer, Image, Header, grommet, Grommet, DateInput, Calendar  } from "grommet";
import { Halt , Search} from "grommet-icons";
import { deepMerge } from "grommet/utils";
import { extractYearFromDateISOString, correctTimeZone } from "../Utils/Utils";
import useTrapFocus from "../Utils/useTrapFocus";
import { getPhenologicalPhaseOptions, } from "../Utils/RBGUtils";
import Draggable from 'react-draggable';


const customTheme = deepMerge(grommet, {
    global: {
        colors: {
            brand: "#801204",
            text: "#801204",
            border: "#801204",
            focus: "#801204",
            icon: "#801204",
        },
    },    
    box: {
        extend: ({ hoverIndicator }) => {
            if (hoverIndicator) {            
                return `
                    &:hover {
                        cursor: ${"pointer"};
                    }
                    `;
            }
        }
    } ,
    calendar: {
        extend: {
            // background: "#FEECEA",
            background: "#FEFAF9",
            border: '3px solid #801204',
            margin: "10px",
        },

        day: {
            extend: {
                color: "#fa8e7f", 
                fontWeight: "bold",
            //    background: "#FFF6F5", // if not commented then not displayed selected date
            }
        },
    },  
                

  });

const ChangePhenologicalPhaseDate = (props) => {
    const [date, setDate] = useState('');
    console.log('props.phenologicalPhaseDateToChange  >>>   ', props.phenologicalPhaseDateToChange)

    // This code will find the object in the phenologicalPhase array that has the specified phaseNumber, 
    // then extract the value from that object and append " Date" to it to create the final formattedText.
    const phaseNumber = props.phenologicalPhaseDateToChange.Phase;
    const phaseString = getPhenologicalPhaseOptions().find((option) => option.index === phaseNumber)?.label;
    const formattedText = phaseString ? phaseString + ' Date' : '';

    // Ref for the modal and focus trap to keep focus within it  
    const modalRef = useRef(null);
    useTrapFocus(modalRef, true); // Trap focus inside the modal while it's open

    useEffect(()=>{
        setDate(props.phenologicalPhaseDateToChange.DateValue);
    },[]);

    const updateValue=(value)=>{
        // console.log('value >> ', value);
        let newDate = value === undefined ? null : correctTimeZone(value);

        // Remove the time component from the ISO strings for comparison
        const newDateWithoutTime = newDate ? newDate.split('T')[0] : '';
        const dateWithoutTime = date ? date.split('T')[0] : '';        

        if (newDateWithoutTime !== dateWithoutTime) {
            setDate(newDate);
          }      
    };

    const draggableRef = useRef(null); // Create a ref

    
    return (
        <Grommet theme={customTheme} > 
            <Layer
                id="change-phen-phase"
                ref={modalRef}
                tabIndex="-1"                
                position="center"
                onEsc={props.onClose}
                onClickOutside={() => {}}
                responsive={true}
                modal
                style={{
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dim background for modal effect
                }}
            >
                {/* <Draggable bounds="parent" nodeRef={draggableRef}>  */}
                <Box 
                    pad="small" 
                    margin="small" 
                    gap="small" 
                    width="medium"  
                    background="#FEF2E8"  
                    border={{ color: "brand"}}
                    style={{
                        position: 'relative',
                        margin: 'auto', // Center horizontally and vertically
                    }}
                >

                    <Box
                        ref={draggableRef}
                        pad="small"
                        background="#FEF2E8"
                        border={{ color: "brand", size: "small" }}
                        round="small"
                        style={{
                            position: 'relative',
                            boxShadow: `0 0 0 3px #FEF2E8`, // Inner border effect
                        }}
                    >                

                        <Box style={{position:"relative"}}>
                            <Header margin="none" background="#fa8e7f" pad="small" height="xxsmall" justify="around">
                                <Text alignSelf="start" size="large"  align="center" >
                                    <strong>Attention!</strong>
                                </Text>
                            </Header>
                            <Box height="xsmall" width="xsmall"  
                                style={{position:"absolute", right: "3%", top: "15px"}}
                                right="0px"
                                >
                                    <Image
                                        size="contain"
                                        src="Grape.png"                                  
                                    />
                            </Box>                 
                        </Box>

                        <Box align="center" margin={{top: 'medium'}}>
                            <Text  margin="large" textAlign="center" ><span style={{whiteSpace: 'pre-line', fontSize: '24px'}}><strong>{props.msg}</strong></span></Text>
                        </Box> 

                        <Box alignContent="between" style={{ padding: "6px 12px"}}  height="90px">
                            <Text alignSelf="start" color="brand" size="18px" style={{ padding: "2px 0 "}}>
                                {formattedText}
                            </Text>

                            <Box >
                            <DateInput 
                                hoverIndicator
                                style={{  padding: "5px 0 5px 10px", fontSize: "large", width: "80%"}}
                                focusIndicator={false}
                                format="dd/mm/yyyy"
                                value={extractYearFromDateISOString(date) > 1900? date : ''}
                                onChange={(event) => {
                                    updateValue(event.value);
                                }}
                            />
                            </Box>
                        </Box>

                        <Box  align="center" margin={{top: "-30px"}} >
                            <Image 
                                size="contain"
                                src="Mole.png"                                  
                            />
                        </Box> 

                        <Box 
                            as="footer"
                            gap="small"
                            direction="row"
                            align="center"
                            justify="center"
                            pad={{ top: 'medium', bottom: 'small' }}
                        >
                            <Button
                                label={
                                <Text color="white">
                                    <strong>Yes</strong>
                                </Text>
                                }
                                onClick={() => props.onConfirm(date)}
                                primary
                            
                            />
                            <Button
                                label={
                                <Text >
                                    <strong>No</strong>
                                </Text>
                                }
                                onClick={() => props.onClose(false)}
                                secondary                   
                            />                                 
                        </Box>
                    </Box>
                </Box>
                {/* </Draggable> */}
            </Layer>
        </Grommet> 
    )
}

export default ChangePhenologicalPhaseDate;